import { render, staticRenderFns } from "./downDeviceRule.vue?vue&type=template&id=07c8fd1c&scoped=true"
import script from "./downDeviceRule.vue?vue&type=script&lang=js"
export * from "./downDeviceRule.vue?vue&type=script&lang=js"
import style0 from "./downDeviceRule.vue?vue&type=style&index=0&id=07c8fd1c&prod&scoped=true&lang=css"
import style1 from "./downDeviceRule.vue?vue&type=style&index=1&id=07c8fd1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c8fd1c",
  null
  
)

export default component.exports